<template>
  <div class="subpage-container">
    <div class="timeline">
    <h3>{{title}}</h3>
      <div  class="event"  v-for="(row, i) in timeline" :key="i">
        <div class="event-container" :class="shift(i)">
          <div class="timeline-event-container" >
            <p class="timeline-text"><span class="timeline-text__dato">{{ row.dato }}:</span> {{ row.hendelse }}</p>
          </div>
        </div>  
        <div v-if="i < timeline.length-1" class="event-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Timeline from './extra/Timeline.vue';

export default {
  components: {  },
  name: "Timeline",
  props: {
    timeline: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: "Tittel",
    },
  },
  data() {
    return { 
      timelineList: []
      }
  },
   methods: {
    shift(id) {
       if( id % 2) {
      return "right";
      
    } else {
      return "left";
    }
    }
  },
  created() {
       
   
  }

};
</script>
<style lang="scss" scoped>
.timeline {
  display: flex;
  flex-direction: column;
  max-width: 460px;
    @include desktop() {
      max-width: 600px;
    }
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
 h3 {
   text-align: center;
   color: color('white');
 }
  .event {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

  .event-line {
        height: 80px;
        width: 2px;
        margin-top: -2rem;
        margin-bottom: -2rem;
        border-left: 3px solid color('red');
      }


    

    &-container {
      z-index: 10;
      max-width: 300px;
      margin: 0.5rem;
      padding: 1rem 0rem;
      background-color: color("white");

      &.left {
        margin-left: auto;
      }
      &.right {
        margin-right: auto;
      }

      @include desktop() {
        max-width: 400px;
        margin-left: 1rem;
        margin-right: 1rem;
      }
    }
  }

  &-text {
    margin: 0 1rem;
    &__dato {
      font-weight: 600;
      color: color("red");
    }
  }
}
</style>

